import { ReactNode } from 'react';
import { Form, Select } from 'antd';
import { Field, useField } from 'formik';

import { Icon, Tag, Text } from 'shared/components/ui';

import styles from './index.module.scss';

interface SelectInputProps {
	name: string;
	placeholder?: string;
	label?: ReactNode;
}

export const FormikSelectWithoutChoice = ({ name, placeholder, label }: SelectInputProps) => {
	const [field, , helper] = useField(name);
	const value: string[] = (field.value as []) || [];

	const handleSelect = (data: string) => {
		if (value?.includes(data)) {
			handleDelete(data);
			return;
		}
		if (!value) {
			helper.setValue([data]);
		} else {
			helper.setValue([...value!, data]);
		}
	};

	const handleDelete = (deleted: string) => {
		helper.setValue(value?.filter((item: string) => item !== deleted) || []);
	};

	const handleChange = (items: string[]) => {
		const previousValues = [...value];
		const addedValues = items.filter(v => !previousValues.includes(v));
		const removedValues = previousValues.filter(v => !items.includes(v));

		addedValues.forEach(val => {
			handleSelect(val);
		});
		removedValues.forEach(val => {
			handleSelect(val);
		});
	};

	const handleClear = () => {
		helper.setValue([], true);
	};

	const handleClose = (item: string) => {
		return () => handleDelete(item);
	};

	return (
		<Field name={name}>
			{({ field, form }: { field: any; form: any }) => (
				<Form.Item
					label={
						<div className={styles.label} onClick={e => e.preventDefault()}>
							<Text variant="inter/15/medium">{label}</Text>
							{value.length > 0 && (
								<div className={styles.labelTag}>
									<Text variant="inter/14/medium">{value.length}</Text>
									<button type="button" onClick={handleClear}>
										<Icon icon="close" />
									</button>
								</div>
							)}
						</div>
					}>
					<Select
						{...field}
						mode="tags"
						style={{ width: '100%' }}
						placeholder={placeholder || 'Enter keywords'}
						onChange={handleChange}
						tokenSeparators={[',']}
						tagRender={props => <Tag label={props.label} onClick={handleClose(props.label as string)} />}
						value={value}
						getPopupContainer={trigger => trigger.parentElement || document.body}
					/>
				</Form.Item>
			)}
		</Field>
	);
};
